"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateStringToSegments = exports.buildValueStringId = void 0;
exports.dateTimeSegmentsToDate = dateTimeSegmentsToDate;
exports.isIsoFormat = exports.hasAnyTimeValue = exports.hasAnySegmentValue = exports.hasAllDateValues = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _dateTimeSegments = require("../date-time-segments");

var _constants = require("./constants");

function dateTimeSegmentsToDate(segmentValues, showSeconds, showMilliseconds) {
  var _ref = segmentValues,
      year = _ref.year,
      month = _ref.month,
      day = _ref.day,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds,
      milliseconds = _ref.milliseconds;
  var parsedDate = Date.UTC(year, month - 1, // Adjust month index
  day, hours, minutes, showSeconds ? seconds : 0, showMilliseconds ? milliseconds : 0);
  return new Date(parsedDate);
}

var dateStringToSegments = function dateStringToSegments(dateString) {
  var date = new Date(dateString);
  return {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    // Adjust month index
    day: date.getUTCDate(),
    hours: date.getUTCHours(),
    minutes: date.getUTCMinutes(),
    seconds: date.getUTCSeconds(),
    milliseconds: date.getUTCMilliseconds()
  };
};

exports.dateStringToSegments = dateStringToSegments;

var hasAnySegmentValue = function hasAnySegmentValue(segmentValues) {
  return Object.values(segmentValues).some(function (value) {
    return value !== undefined;
  });
};

exports.hasAnySegmentValue = hasAnySegmentValue;

var isIsoFormat = function isIsoFormat(dateString) {
  return _constants.ISO_FORMAT.test(dateString);
};

exports.isIsoFormat = isIsoFormat;

var buildValueStringId = function buildValueStringId(id) {
  return "".concat(id, "-value-string");
};

exports.buildValueStringId = buildValueStringId;

var hasAllDateValues = function hasAllDateValues(segmentValues) {
  return [segmentValues[_dateTimeSegments.DateTimeSegment.Year], segmentValues[_dateTimeSegments.DateTimeSegment.Month], segmentValues[_dateTimeSegments.DateTimeSegment.Day]].every(function (value) {
    return value !== undefined;
  });
};

exports.hasAllDateValues = hasAllDateValues;

var hasAnyTimeValue = function hasAnyTimeValue(segmentValues, showSeconds, showMilliseconds) {
  return [segmentValues[_dateTimeSegments.DateTimeSegment.Hours], segmentValues[_dateTimeSegments.DateTimeSegment.Minutes]].concat((0, _toConsumableArray2.default)(showSeconds ? [segmentValues[_dateTimeSegments.DateTimeSegment.Seconds]] : []), (0, _toConsumableArray2.default)(showMilliseconds ? [segmentValues[_dateTimeSegments.DateTimeSegment.Milliseconds]] : [])).some(function (value) {
    return value !== undefined;
  });
};

exports.hasAnyTimeValue = hasAnyTimeValue;